import { useState } from "react";
import { Download } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { StoryExportDialog } from "@/components/story/story-export-dialog";
import type { StoryExportResult, StoryExportTemplateView } from "@/types/story";

type StoryExportButtonProps = {
  onExport: (templateId: string) => Promise<StoryExportResult>;
  targetTitle: string;
  templates: StoryExportTemplateView[];
};

export function StoryExportButton({
  onExport,
  targetTitle,
  templates,
}: StoryExportButtonProps) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);

  if (templates.length === 0) {
    return null;
  }

  return (
    <>
      <Button onClick={() => setOpen(true)} type="button" variant="outline">
        <Download className="h-4 w-4" />
        {t("story.export.button")}
      </Button>
      <StoryExportDialog
        onExport={onExport}
        onOpenChange={setOpen}
        open={open}
        targetTitle={targetTitle}
        templates={templates}
      />
    </>
  );
}
